import { render, staticRenderFns } from "./DosingMain.vue?vue&type=template&id=ed124b6c"
import script from "./DosingMain.vue?vue&type=script&lang=js"
export * from "./DosingMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports